import axios from 'axios';
import { useQuery } from 'react-query';
import { getSkills } from './skills';

export const useGetSkillsBySubject = (subjectId: string) => {
  const queryResponse = useQuery(
    ['getSkills', subjectId],
    async () => {
      if (!subjectId) {
        return [];
      }
      const response = await getSkills(subjectId);
      return response || [];
    },
    {
      suspense: true,
      staleTime: 60 * 60 * 24,
      refetchOnMount: 'always',
    },
  );

  return {
    data: queryResponse?.data,
    isLoading: queryResponse.isLoading,
  };
};

export const useGetSkillsByStandard = (subjectId: string, standardIds: string[]) => {
  const queryResponse = useQuery(
    ['getSkills', subjectId, standardIds],
    async () => {
      if (!subjectId || !standardIds.length) {
        return [];
      }
      const response = await getSkills(subjectId, standardIds);
      return response || [];
    },
    {
      suspense: true,
      staleTime: 60 * 60 * 24,
      refetchOnMount: 'always',
    },
  );

  return {
    data: queryResponse?.data,
    isLoading: queryResponse.isLoading,
  };
};

export const postQGSQuestionRequest = (payload: any) =>
  axios.post('/api/qgs/questions', payload).then((response) => ({ response }));

export const submitQuestionsToItemBank = (payload: any) =>
  axios.post('/api/qgs/questions/submit', payload).then((response) => ({ response }));

export const postUserReportIssue = (payload: {
  trace_id: string | null;
  content_type: string;
  content: string;
}) => axios.post('/api/users/v2/report-issue/', payload);

export const getQGSSupportedQuestionTypes = () => axios.get('/api/qgs/question-types');

export const postPassageUpsert = (payload) => axios.post('/api/qgs/passages/', payload);

export const generatePassageWithAI = (prompt: string) =>
  axios.post('/api/qgs/passages/generate', { user_prompt: prompt });

export const getPassageDetail = (reference: string) => {
  const url = `/api/qgs/passages/?reference=${reference}`;
  return axios.get(url).then((response) => ({ response }));
};
